import { env } from 'next-runtime-env';
import {
  getBffLocalProxyBaseUrl,
  isBffLocalProxyEnabled,
} from '@/core/constants/bff-local-proxy';

const configuredBackendApiUrl =
  env('NEXT_PUBLIC_BACKEND_API_URL') ||
  process.env.NEXT_PUBLIC_BACKEND_API_URL ||
  '';

/**
 * When NEXT_PUBLIC_BFF_LOCAL_PROXY=true, browser calls go same-origin via
 * `/api/bff-proxy` so auth-v1 SameSite=Strict cookies work on localhost.
 * Keep NEXT_PUBLIC_BACKEND_API_URL as the real API origin (proxy target).
 */
export const BACKEND_API_URL = isBffLocalProxyEnabled()
  ? getBffLocalProxyBaseUrl()
  : configuredBackendApiUrl;
export const GCP_RITUALS_API_URL =
  env('NEXT_PUBLIC_GCP_RITUALS_API_URL') ||
  process.env.NEXT_PUBLIC_GCP_RITUALS_API_URL ||
  '';

export const GI_API_URL =
  env('NEXT_PUBLIC_GI_API_URL') || process.env.NEXT_PUBLIC_GI_API_URL || '';

export const ENDPOINTS = {
  signInPassword: '/auth/v1/bff/sign-in/password',
  signInRefresh: '/auth/v1/bff/sign-in/refresh',
  signInIdToken: '/auth/v1/bff/sign-in/id-token',
  socialProviders: '/auth/v1/bff/social/providers',
  socialValidate: '/auth/v1/bff/social/validate',
  socialLink: '/auth/v1/bff/social/link',
  profile: '/profiles/v1/bff/profile',
  profileShippingAddress: '/profiles/v1/bff/profile/shipping-address',
  profileBillingAddress: '/profiles/v1/bff/profile/billing-address',
  validate: '/profiles/v1/bff/account/validate',
  sendOobCode: '/identity/v1/accounts:sendOobCode',
  resetPassword: '/v1/accounts:resetPassword',
  supportCase: '/support/v1/bff/support-case',
  supportConfigurations: '/support/v1/bff/configurations',
  supportFaqs: '/support/v1/bff/faqs',
  // Booking endpoints
  locations: '/bookings/v1/bff/locations',
  services: '/bookings/v1/bff/services',
  availability: '/bookings/v1/bff/availability',
  bookings: '/bookings/v1/bff/bookings',
  bookingsByCode: '/bookings/v1/bff/bookings/by-code',
  // Orders BFF
  orders: '/orders/v1/bff/orders',
  // Subscriptions BFF (user)
  subscriptions: '/subscriptions/v1/bff/subscriptions',
  // Catalog BFF
  catalogProducts: '/catalog/v1/bff/products',
  catalogSubscriptions: '/catalog/v1/bff/subscriptions',
  // Shopping carts BFF
  shoppingCarts: '/carts/v1/bff/carts',
  shoppingCartAddresses: '/carts/v1/bff/addresses',
} as const;

export const BACKEND_API_KEY =
  env('NEXT_PUBLIC_BACKEND_API_KEY') ||
  process.env.NEXT_PUBLIC_BACKEND_API_KEY ||
  '';

export const CONTACT_API_KEY =
  env('NEXT_PUBLIC_CONTACT_API_KEY') ||
  process.env.NEXT_PUBLIC_CONTACT_API_KEY ||
  '';

export const TENANT_ID =
  env('NEXT_PUBLIC_RESET_PASSWORD_TENANT_ID') ||
  process.env.NEXT_PUBLIC_RESET_PASSWORD_TENANT_ID ||
  '';
